import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';
import { map, catchError, of, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const auth    = inject(AuthService);
  const router  = inject(Router);

  const token = storage.getAccessToken();
  if (!token) {
    router.navigate(['/login']);
    return false;
  }

  // If we already have the user loaded, check is_staff
  if (auth.currentUser()) {
    if (auth.isStaff()) return true;
    router.navigate(['/login']);
    return false;
  }

  // Load user from API
  return auth.loadCurrentUser().pipe(
    map(user => {
      if (user.is_staff) return true;
      router.navigate(['/login']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/login']);
      return of(false);
    })
  );
};

export const guestGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const router  = inject(Router);

  const token = storage.getAccessToken();
  if (token) {
    router.navigate(['/usuarios']);
    return false;
  }
  return true;
};
